import { render, staticRenderFns } from "./naoDeals.vue?vue&type=template&id=28e2398f&scoped=true&"
import script from "./naoDeals.vue?vue&type=script&lang=js&"
export * from "./naoDeals.vue?vue&type=script&lang=js&"
import style0 from "./naoDeals.vue?vue&type=style&index=0&id=28e2398f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2398f",
  null
  
)

export default component.exports